// being used

import React, { useEffect, useState } from "react";
import PPERecordsComponent from "./recordsTable";
import ComplianceTable from "./ppeSummary";

import {
  fetchPPERecords,
  calculateComplianceData,
  flattenQuestions,
  formatCreatedAtDate,
} from "./ppeRecordsUtils";
import { Button } from "@mui/material";
import PPEForm from "./ppeForm";
import DataFiltersComponent from "../DataFiltersComponent";
import { getPPERecords, getUserNames } from "../../../service/endpoint-manager";

import { Grid, Typography } from "@material-ui/core";

import {
  getCurrentDate,
  getFirstDayOfMonth,
  getUniqueUserIds,
} from "@thequantumhub/iam-package";

const DashboardPPE = () => {
  const [ppeRecords, setPPERecords] = useState([]);
  const [complianceData, setComplianceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [strict, setStrict] = useState(false);
  const [timeFilter, setTimeFilter] = useState("weekly");
  const [columnView, setColumnView] = useState("moment");

  // Filter Component
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("");
  const [recordStatus, setRecordStatus] = useState("Active");
  const [selectedHealthcareWorker, setSelectedHealthcareWorker] =
    useState("All");
  const [selectedUser, setSelectedUser] = useState("All");
  const [startDate, setStartDate] = useState(getFirstDayOfMonth());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const [isDashboard, setIsDashboard] = useState(true);

  const [userNames, setUserNames] = useState([]);

  useEffect(() => {
    const fetchAndProcessRecords = async () => {
      try {
        const records = await fetchPPERecords();
        const userList = getUniqueUserIds(records, "createdBy");
        var result = await getUserNames(userList);
        setUserNames(result.data.body);
        setPPERecords(records);
        const compliance = calculateComplianceData(records, strict);
        setComplianceData(compliance);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAndProcessRecords();
  }, [strict]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleStrictChange = (event) => {
    setStrict(event.target.checked);
  };
  const handleTimeFilterChange = (newFilter) => {
    setTimeFilter(newFilter);
  };

  const handleColumnViewChange = (view) => {
    setColumnView(view);
  };

  // Filter logic
  useEffect(() => {
    loadData();
  }, [
    startDate,
    endDate,
    selectedUnit,
    recordStatus,
    selectedHealthcareWorker,
    selectedUser,
  ]);

  const loadData = async () => {
    try {
      var tempStartDate = new Date(startDate);
      var tempendDate = new Date(endDate);
      const response = await getPPERecords({
        deleted: recordStatus === "Deleted",
        from: tempStartDate.toISOString(),
        to: tempendDate.toISOString(),
      });
      let records = response.data.body;

      if (selectedUnit && selectedUnit !== "all") {
        records = records.filter((record) => record.unit === selectedUnit);
      }
      if (selectedHealthcareWorker !== "All") {
        records = records.filter(
          (record) => record.healthCareWorker === selectedHealthcareWorker
        );
      }
      if (selectedUser && selectedUser !== "All") {
        records = records.filter((record) => record.createdBy === selectedUser);
      }

      setPPERecords(records);
      const compliance = calculateComplianceData(records, strict);
      setComplianceData(compliance);
    } catch (error) {
      console.error("Error fetching PPE records:", error);
    }
  };

  const resetFilters = () => {
    setUnits([]);
    setSelectedUnit("");
    setRecordStatus("Active");
    setSelectedHealthcareWorker("All");
    setSelectedUser("All");
    setStartDate("");
    setEndDate("");
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      {isDashboard ? (
        <>
          <DataFiltersComponent
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            selectedUnit={selectedUnit}
            setSelectedUnit={setSelectedUnit}
            units={units}
            setUnits={setUnits}
            recordStatus={recordStatus}
            setRecordStatus={setRecordStatus}
            selectedHealthcareWorker={selectedHealthcareWorker}
            setSelectedHealthcareWorker={setSelectedHealthcareWorker}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            resetFilters={resetFilters}
          />
          <ComplianceTable
            ppeRecords={ppeRecords}
            timeFilter={timeFilter}
            columnView={columnView}
            strict={strict}
            handleStrictChange={handleStrictChange}
            handleColumnViewChange={handleColumnViewChange}
            handleTimeFilterChange={handleTimeFilterChange}
          />

          <div>
            <PPERecordsComponent
              ppeRecords={ppeRecords}
              setPPERecords={setPPERecords}
              complianceData={calculateComplianceData(ppeRecords, strict)}
              page={page}
              rowsPerPage={rowsPerPage}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              flattenQuestions={flattenQuestions}
              formatCreatedAtDate={formatCreatedAtDate}
              strict={strict}
              setIsDashboard={setIsDashboard}
              userNames={userNames}
            />
          </div>
        </>
      ) : (
        <>
          <Grid container alignItems="center">
            <Grid item xs={12} sm={4}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setIsDashboard(true);
                }}
              >
                Return to Dashboard
              </Button>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Typography
                variant="h2"
                style={{ textAlign: "center", margin: "20px 0" }}
              >
                PPE Audit
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}></Grid>
          </Grid>
          <PPEForm />
        </>
      )}
    </>
  );
};

export default DashboardPPE;
